import { render, staticRenderFns } from "./UserDocuments.vue?vue&type=template&id=0ef10805"
import script from "./UserDocuments.js?vue&type=script&lang=js&external"
export * from "./UserDocuments.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports